import { ReactNode } from 'react';
import ErrorTriangle from '~components/icons/error_triangle';
import { cn } from '~utils/classnames';

export interface iErrorImage {
  position?: 'left' | 'center' | 'right';
  children?: ReactNode | undefined;
  icon?: ReactNode | undefined;
}

function ErrorBlock({ children = undefined, icon = undefined, position = 'right' }: iErrorImage) {
  return (
    <div
      className={cn('transition inline-block bg-surface-primary text-error-text p-4 rounded-2xl shadow-error-block border-[2px]', {
        'absolute top-1/5 xs:top-3/5 right-0 translate-x-3/5 xs:-translate-y-1/3': position === 'right',
        'absolute top-1/5 left-0 -translate-x-3/5 xs:translate-y-1/10': position === 'left',
        'my-10': position === 'center',
      })}
    >
      <div className="flex flex-col xs:flex-row font-bold flex-nowrap gap-2 text-2xl items-center font-heading leading-(--leading-default)">
        {icon ?? <ErrorTriangle />}
        {children && <span>{children}</span>}
      </div>
    </div>
  );
}

export default ErrorBlock;
